<a mat-list-item (click)="toggle()" style="width: fit-content;">
    <div fxLayout="row" fxLayoutAlign="space-between stretch" [ngClass]="{'expandido': menuPrincipalService.expandido}"
        class="submenu">
        <div fxLayout="row" fxLayoutAlign="start stretch" matTooltip="Tabelas de Referência">
            <mat-icon>table_chart</mat-icon>
            <span *ngIf="menuPrincipalService.expandido" class="nav-caption">Tabelas de Referência</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="start stretch">
            <mat-icon *ngIf="menuPrincipalService.expandido" style="padding-top: 2px">{{getIcone()}}</mat-icon>
        </div>
    </div>
</a>

<mat-nav-list [ngClass]="{'expandido': menuPrincipalService.expandido}">

    <div [hidden]="!isMostrarSubMenu" [@menuState]="currentState">

        <!-- TIPOS_DOADORES -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().TIPOS_DOADORES)" icone="list" titulo="Tipos de doadores"
                rota="tiposdoadores" toolTip="Tipos de doadores"></sub-menu>
        </div>

        <!-- DOADORES -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().DOADORES)" icone="list" titulo="Doadores"
                rota="doadores" toolTip="Doadores"></sub-menu>
        </div>

        <!-- BENEFICIOS_SOCIAIS -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().BENEFICIOS_SOCIAIS)" icone="list" titulo="Benefícios Sociais"
                rota="beneficiossociais" toolTip="Benefícios Sociais"></sub-menu>
        </div>

        <!-- TIPO_CONTRATO -->
        <div style="padding-left: 15px">
            <sub-menu *ngIf="verificaAcesso(getModulos().TIPO_CONTRATO)" icone="list" titulo="Tipos de Contratos"
                rota="tipocontrato" toolTip="Tipo de Contrato"></sub-menu>
        </div>

    </div>
</mat-nav-list>